import { render, staticRenderFns } from "./TextBeforeInputNumber.vue?vue&type=template&id=2c41f82b"
import script from "./TextBeforeInputNumber.vue?vue&type=script&lang=ts"
export * from "./TextBeforeInputNumber.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports